import './notizie-list.scss';

export class NotizieList {}
